<template>
  <section class="form__content">
    <h3>2. {{ $t('contactDetails.title') }}</h3>

    <v-form v-model="formValidation">
      <v-radio-group :value="sex"
                     @change="$emit('update:sex', $event)"
                     :label="$t('contactDetails.sexChoices.label')"
                     :rules="[v => !!v || $t('error.required')]"
      >
        <v-radio :label="$t('contactDetails.sexChoices.male')" value="M"/>
        <v-radio :label="$t('contactDetails.sexChoices.female')" value="F"/>
      </v-radio-group>

      <v-text-field :value="lastName"
                    :label="$t('contactDetails.lastName')"
                    @input="$emit('update:lastName', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="firstName"
                    :label="$t('contactDetails.firstName')"
                    @input="$emit('update:firstName', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="nationality"
                    :label="$t('contactDetails.nationality')"
                    @input="$emit('update:nationality', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />


      <v-menu ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field :value="birthday"
                        :label="$t('contactDetails.birthday')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        required
                        :rules="[v => !!v || $t('error.required')]"
          />
        </template>
        <v-date-picker ref="picker"
                       :value="birthday"
                       @change="onSelectBirthday"
                       :max="new Date().toISOString().substr(0, 10)"
                       min="1950-01-01"
        />
      </v-menu>

      <v-text-field :value="birthLocation"
                    :label="$t('contactDetails.birthLocation')"
                    @input="$emit('update:birthLocation', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="address"
                    :label="$t('contactDetails.address')"
                    @input="$emit('update:address', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="zipCode"
                    :label="$t('contactDetails.zipCode')"
                    @input="$emit('update:zipCode', $event)"
      />
      <v-text-field :value="city"
                    :label="$t('contactDetails.city')"
                    @input="$emit('update:city', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="country"
                    :label="$t('contactDetails.country')"
                    @input="$emit('update:country', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field v-if="hasPhone"
                    :value="phone"
                    :label="$t('contactDetails.phone')"
                    @input="$emit('update:phone', $event)"
                    type="tel"
      />
      <v-text-field :value="mail"
                    :label="$t('contactDetails.mail')"
                    @input="$emit('update:mail', $event)"
                    required
                    :rules="[v => !!v || $t('error.required'), emailValidation]"
                    type="email"
      />

      <v-select v-if="hasStatus"
                :value="status"
                @input="$emit('update:status', $event)"
                :label="$t('contactDetails.status.label')"
                :items="statusItems"
                required
                :rules="[v => !!v || $t('error.required')]"
      />

      <v-text-field v-if="status === 'other'"
                    :value="titleOther"
                    :label="$t('contactDetails.titleOther')"
                    @input="$emit('update:titleOther', $event)"
      />

      <v-text-field v-if="isPhd"
                    :value="titleClassName"
                    :label="$t('contactDetails.titleClassName')"
                    @input="$emit('update:titleClassName', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />

      <v-text-field v-if="isPhd"
                    :value="titleClassDate"
                    :label="$t('contactDetails.titleClassDate')"
                    @input="$emit('update:titleClassDate', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
    </v-form>
  </section>
</template>

<script>
import validationMixin from '@/mixins/validationMixin'

export default {
  name: 'ContactDetails',

  mixins: [validationMixin],

  props: {
    valid: {
      required: true,
    },
    address: {
      required: true,
    },
    birthday: {
      required: true,
    },
    birthLocation: {
      required: true,
    },
    city: {
      required: true,
    },
    country: {
      required: true,
    },
    firstName: {
      required: true,
    },
    lastName: {
      required: true,
    },
    mail: {
      required: true,
    },
    nationality: {
      required: true,
    },
    phone: {
      required: false,
      default: null,
    },
    sex: {
      required: true,
    },
    status: {
      required: false,
      default: null,
    },
    statusItems: {
      required: false,
      default: null,
    },
    titleClassName: {
      required: false,
    },
    titleClassDate: {
      required: false,
    },
    titleOther: {
      required: true,
    },
    zipCode: {
      required: true,
    },
  },

  data: () => ({
    formValidation: false,
    menu: false,
  }),

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  computed: {
    hasPhone () {
      return this.phone !== null
    },
    hasStatus () {
      return this.status !== null
    },
    isPhd () {
      return this.status === 'phdStudentCDE'
        || this.status === 'phdStudentIDEX'
        || this.status === 'coPhd'
    },
  },

  methods: {
    onSelectBirthday (event) {
      this.menu = false
      this.$emit('update:birthday', event)
    },
  },
}
</script>
